import { Button, Col, Popover, Row } from "antd";
import { FaEye } from "react-icons/fa";
import { EllipsisOutlined } from "@ant-design/icons";
import moment from "moment";
import { jobStatus } from "./CreateJobView/constants";
import ConditionalRender from "../../reusable-components/ConditionalRender";
import { DateFormat } from "../../enums/dateTimeFormat";
import styles from "./CreateJobListing.module.scss";
import clsx from "clsx";
//Might need interface
export interface JobColumnsProps {
  handleViewNavigate: (record: any) => void;
  salesPersonData?: any[];
}
export interface FilterProps {
  statusFilter?: string;
  customerFilter?: string;
  salesFilter?: string;
}
export interface JobData {
  dropOffLatLng: {
    lng: number;
    lat: number;
  };
  jobNumber: number;
  agreementDescription: string;
  accountChargeLimit: string;
  email: {
    companyId: string;
    sent: boolean;
    projectId: string;
    conatctId: string;
  };
  signature: string;
  accountTerms: string;
  dropoff: string;
  leadId: string;
  updatedAt: number;
  jobType: string;
  salesPersonId: string;
  id: string;
  paymemtTerms: string;
  material: any[];
  stageId: string;
  invoiceResult: any[];
  multipleContacts: any[];
  // Add other properties as needed
}
export const CreateJobViewConstants = {
  NO_SEARCH_DATA: "No jobs found. Try adjusting the search criteria.",
  NO_JOB_DATA: "No jobs available.",
  EDIT_ACCESS_REQUIRED: "Access required to edit job",
  SHOW_BLOCKED: "Show blocked",
  ADD_JOB_BTN_TEXT: "+ Add Job",
  TRUE_STRING: "true",
};
export const CancelStyles = {
  color: "#586370",
  backgroundColor: "white",
  border: "1px solid #e1e1e1",
  borderRadius: "1px",
  fontFamily: "Montserrat, sans-serif",
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "22px",
  textShadow: "none",
  borderRadius: "8px",
};
export const ButtonGroupStyles = {
  color: "#586370",
  backgroundColor: "white",
  border: "1px solid transparent",

  fontFamily: "Montserrat, sans-serif",
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "22px",
  textShadow: "none",
};

export type JobStatus =
  | "Build Quote"
  | "Quote Shared"
  | "Quote Approved"
  | "Quote Accepted"
  | "L1 Rejected"
  | "L1 Approval Pending"
  | "L2 Rejected"
  | "L2 Approval Pending"
  | "L2 Approved"
  | "Internal Approval Complete"
  | "Dispatch Approved"
  | "Contacted"
  | "Close Job"
  | "Material and Trucking Details"
  | "Job Lead"
  | "Internal Approval Draft";

export type StatusConfig = {
  color: string;
  label: string;
};

export const JOB_STATUS_CONFIG: Record<JobStatus, StatusConfig> = {
  "Build Quote": {
    color: "var(--status-blue)",
    label: "Build Quote",
  },
  "Quote Shared": {
    color: "var(--status-blue)",
    label: "Quote Shared",
  },
  "Material and Trucking Details": {
    color: "var(--status-blue)",
    label: "Material and Trucking Details",
  },
  Contacted: {
    color: "var(--status-blue)",
    label: "Contacted",
  },
  "Quote Approved": {
    color: "var(--status-green)",
    label: "Quote Approved",
  },
  "Quote Accepted": {
    color: "var(--status-green)",
    label: "Quote Accepted",
  },
  "L2 Approved": {
    color: "var(--status-green)",
    label: "L2 Approved",
  },
  "Internal Approval Draft": {
    color: "var(--status-yellow)",
    label: "Internal Approval Draft",
  },
  "Internal Approval Complete": {
    color: "var(--status-green)",
    label: "Internal Approval Complete",
  },
  "Dispatch Approved": {
    color: "var(--status-green)",
    label: "Dispatch Approved",
  },
  "L1 Approval Pending": {
    color: "var(--status-yellow)",
    label: "L1 Approval Pending",
  },
  "L2 Approval Pending": {
    color: "var(--status-yellow)",
    label: "L2 Approval Pending",
  },
  "L1 Rejected": {
    color: "var(--status-red)",
    label: "L1 Rejected",
  },
  "L2 Rejected": {
    color: "var(--status-red)",
    label: "L2 Rejected",
  },
  "Close Job": {
    color: "var(--status-red)",
    label: "Dispatch Approved",
  },
};

const getStatusStyle = (status: JobStatus | undefined) => {
  const defaultStyle = {
    textTransform: "capitalize" as const,
    color: "var(--status-default)",
    fontSize: "14px",
    fontFamily: "Montserrat, sans-serif",
    display: "inline-block",
    fontWeight: 500,
  };

  if (!status || !JOB_STATUS_CONFIG[status]) {
    return defaultStyle;
  }

  const config = JOB_STATUS_CONFIG[status];
  return {
    ...defaultStyle,
    color: config.color,
  };
};

export const customerColumns = ({ handleViewNavigate }: JobColumnsProps) => [
  {
    title: "Job ID",
    dataIndex: "jobNumber",
    key: "jobNumber",
    sorter: false,
    width: "6%",
    render: (jobNumber: number, record: any) => {
      return (
        <>
          <span
            style={{
              textTransform: "capitalize",
              color: "#474747",
              fontSize: "14px",
              fontfamily: "Montserrat, sans-serif",
            }}
            className={clsx("table-font-mobile", {
              [styles.blockedJob]: !!record?.isBlocked,
            })}
          >
            {jobNumber}
          </span>
        </>
      );
    },
  },
  {
    title: "Job Name",
    dataIndex: "",
    key: "",
    sorter: false,
    width: "200px",
    render: (record) => {
      return (
        <>
          <span
            style={{
              textTransform: "capitalize",
              color: "#474747",
              fontSize: "14px",
              fontfamily: "Montserrat, sans-serif",
            }}
            className={clsx("table-font-mobile", {
              [styles.blockedJob]: !!record?.isBlocked,
            })}
          >
            {record?.jobName ? record?.jobName : record?.jobNumber}
          </span>
        </>
      );
    },
  },
  {
    title: "Job Type",
    dataIndex: "jobType",
    key: "jobType",
    sorter: false,
    width: "140px",
    render: (jobType, record) => {
      return (
        <>
          <span
            style={{
              textTransform: "capitalize",
              color: "#474747",
              fontSize: "14px",
              fontfamily: "Montserrat, sans-serif",
            }}
            className={clsx("table-font-mobile", {
              [styles.blockedJob]: !!record?.isBlocked,
            })}
          >
            {jobType?.replace("Job", "")}
          </span>
        </>
      );
    },
  },
  {
    title: "Customer",
    dataIndex: "companyName",
    key: "companyName",
    sorter: false,
    width: "240px",
    render: (companyName, record) => {
      return (
        <>
          <span
            style={{
              textTransform: "capitalize",
              color: "#474747",
              fontSize: "14px",
              fontfamily: "Montserrat, sans-serif",
            }}
            className={clsx("table-font-mobile", {
              [styles.blockedJob]: !!record?.isBlocked,
            })}
          >
            {companyName}
          </span>
        </>
      );
    },
  },
  {
    title: "Contact Name",
    dataIndex: "multipleContacts",
    key: "multipleContacts",
    sorter: false,
    width: "180px",
    render: (multipleContacts, record) => {
      return (
        <>
          <span
            style={{
              textTransform: "capitalize",
              color: "#474747",
              fontSize: "14px",
              fontfamily: "Montserrat, sans-serif",
            }}
            className={clsx("table-font-mobile", {
              [styles.blockedJob]: !!record?.isBlocked,
            })}
          >
            {multipleContacts?.length > 0 &&
              multipleContacts[0]?.firstName +
                " " +
                multipleContacts[0]?.lastName}
          </span>
        </>
      );
    },
  },
  {
    title: "Sales Person",
    dataIndex: "salesPerson",
    key: "salesPerson",
    sorter: false,
    width: "180px",
    render: (value, record) => {
      return (
        <>
          <span
            style={{
              textTransform: "capitalize",
              color: "#474747",
              fontSize: "14px",
              fontfamily: "Montserrat, sans-serif",
            }}
            className={clsx("table-font-mobile", {
              [styles.blockedJob]: !!record?.isBlocked,
            })}
          >
            {value}
          </span>
        </>
      );
    },
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    sorter: false,
    width: "160px",
    render: (phone, record) => {
      return (
        <>
          <span
            style={{
              textTransform: "capitalize",
              color: "#474747",
              fontSize: "14px",
              fontfamily: "Montserrat, sans-serif",
            }}
            className={clsx("table-font-mobile", {
              [styles.blockedJob]: !!record?.isBlocked,
            })}
          >
            {record?.multipleContacts?.length > 0 &&
              record?.multipleContacts[0]?.phone}
          </span>
        </>
      );
    },
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    sorter: false,
    width: "140px",
    render: (createdAt, record) => {
      return (
        <>
          <span
            style={{
              textTransform: "capitalize",
              color: "#474747",
              fontSize: "14px",
              fontfamily: "Montserrat, sans-serif",
            }}
            className={clsx("table-font-mobile", {
              [styles.blockedJob]: !!record?.isBlocked,
            })}
          >
            {moment(createdAt).format(DateFormat.MMM_DD_YYYY)}
          </span>
        </>
      );
    },
  },
  {
    title: "Status",
    dataIndex: "stageId",
    key: "stageId",
    sorter: false,
    width: "250px",

    render: (stageId: string | undefined, record: any) => {
      const status = stageId as JobStatus | undefined;
      return (
        <span
          style={getStatusStyle(status)}
          className={clsx("table-font-mobile", {
            [styles.blockedJob]: !!record?.isBlocked,
          })}
        >
          {status && JOB_STATUS_CONFIG[status]
            ? JOB_STATUS_CONFIG[status].label
            : stageId || "-"}
        </span>
      );
    },
  },
  {
    title: "Last Action",
    dataIndex: "updatedAt",
    key: "updatedAt",
    sorter: false,
    width: "140px",
    render: (updatedAt, record) => {
      return (
        <>
          <span
            style={{
              textTransform: "capitalize",
              color: "#474747",
              fontSize: "14px",
              fontfamily: "Montserrat, sans-serif",
            }}
            className={clsx("table-font-mobile", {
              [styles.blockedJob]: !!record?.isBlocked,
            })}
          >
            {moment(updatedAt).format(DateFormat.MMM_DD_YYYY)}
          </span>
        </>
      );
    },
  },
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    sorter: false,
    width: "3%",
    fixed: "right",
    render: (actions, record) => {
      return (
        <Row
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
            flexWrap: "nowrap",
          }}
        >
          <Col>
            <Popover
              placement="bottomRight"
              content={
                <Row className="popovergrid" style={{ maxWidth: "90px" }}>
                  {
                    <Col span={24}>
                      <Button
                        className="btn_edit"
                        onClick={() => handleViewNavigate(record)}
                      >
                        <span className="span_edit">
                          <FaEye
                            className="table-font-mobile"
                            style={{ marginRight: "5px" }}
                          />{" "}
                          Review
                        </span>
                      </Button>
                    </Col>
                  }
                </Row>
              }
            >
              <EllipsisOutlined
                style={{ fontSize: "30px", color: "#C3C8CD" }}
                className="action-ellipsis-button"
              />
            </Popover>
          </Col>
        </Row>
      );
    },
  },
];

export const FILTER_FIELD_NAMES_TO_COUNT = [
  "salesPerson",
  "customerName",
  "jobStatus",
  "fromDate",
];
